/*
 Summary: A listing of directives
 */
module.exports = function (app) {
    require("./dateInput")(app);
    require("./collapsibleHours")(app);
    //require("./currentLocation")(app);
    require("./portalAddress")(app);
    require("./portalPhones")(app);
};